export default __webpack_public_path__ + "static/char-s-62-en-99b9f2ce10ddc75dfad44d9171248aba.png";